var _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _g2, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReconcile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 201,
    viewBox: "0 0 152 201",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1789_42435)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 130.645,
    height: 180,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.1037,
    y: 10.1037,
    width: 130.438,
    height: 179.793,
    stroke: "#E9E9E9",
    strokeWidth: 0.207373
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 113.687,
    y: 66.8203,
    width: 14.1014,
    height: 3.31797,
    rx: 1.65899,
    fill: "#E9E9E9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 113.687,
    y: 73.871,
    width: 14.1014,
    height: 3.31797,
    rx: 1.65899,
    fill: "#E9E9E9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 113.687,
    y: 80.9217,
    width: 14.1014,
    height: 3.31797,
    rx: 1.65899,
    fill: "#E9E9E9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 113.687,
    y: 88.8018,
    width: 14.1014,
    height: 3.31797,
    rx: 1.65899,
    fill: "#E9E9E9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 113.687,
    y: 97.0968,
    width: 14.1014,
    height: 3.31797,
    rx: 1.65899,
    fill: "#E9E9E9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 113.687,
    y: 170.092,
    width: 14.1014,
    height: 3.31797,
    rx: 1.65899,
    fill: "#D6D6D6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 113.687,
    y: 105.392,
    width: 14.1014,
    height: 3.31797,
    rx: 1.65899,
    fill: "#E9E9E9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 113.687,
    y: 112.442,
    width: 14.1014,
    height: 3.31797,
    rx: 1.65899,
    fill: "#E9E9E9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 113.687,
    y: 119.493,
    width: 14.1014,
    height: 3.31797,
    rx: 1.65899,
    fill: "#E9E9E9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 113.687,
    y: 127.373,
    width: 14.1014,
    height: 3.31797,
    rx: 1.65899,
    fill: "#E9E9E9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 113.687,
    y: 135.668,
    width: 14.1014,
    height: 3.31797,
    rx: 1.65899,
    fill: "#E9E9E9"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 113.687,
    y: 143.963,
    width: 14.1014,
    height: 3.31797,
    rx: 1.65899,
    fill: "#E9E9E9"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 113.687,
    y: 151.843,
    width: 14.1014,
    height: 3.31797,
    rx: 1.65899,
    fill: "#E9E9E9"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 113.687,
    y: 160.138,
    width: 14.1014,
    height: 3.31797,
    rx: 1.65899,
    fill: "#E9E9E9"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 24.5166,
    y: 66.8203,
    width: 42.7189,
    height: 3.31797,
    rx: 1.65899,
    fill: "#E9E9E9"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 24.5166,
    y: 73.871,
    width: 28.2028,
    height: 3.31797,
    rx: 1.65899,
    fill: "#E9E9E9"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 24.5166,
    y: 80.9217,
    width: 38.5714,
    height: 3.31797,
    rx: 1.65899,
    fill: "#E9E9E9"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 24.5166,
    y: 88.8018,
    width: 49.7696,
    height: 3.31797,
    rx: 1.65899,
    fill: "#E9E9E9"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 24.5166,
    y: 97.0968,
    width: 35.2535,
    height: 3.31797,
    rx: 1.65899,
    fill: "#E9E9E9"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 24.5166,
    y: 105.392,
    width: 51.4286,
    height: 3.31797,
    rx: 1.65899,
    fill: "#E9E9E9"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 24.5166,
    y: 112.442,
    width: 23.2258,
    height: 3.31797,
    rx: 1.65899,
    fill: "#E9E9E9"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 24.5166,
    y: 119.493,
    width: 38.5714,
    height: 3.31797,
    rx: 1.65899,
    fill: "#E9E9E9"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 24.5166,
    y: 127.373,
    width: 42.7189,
    height: 3.31797,
    rx: 1.65899,
    fill: "#E9E9E9"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 24.5166,
    y: 135.668,
    width: 33.1797,
    height: 3.31797,
    rx: 1.65899,
    fill: "#E9E9E9"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 24.5166,
    y: 143.963,
    width: 34.8387,
    height: 3.31797,
    rx: 1.65899,
    fill: "#E9E9E9"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 24.5166,
    y: 151.843,
    width: 51.4286,
    height: 3.31797,
    rx: 1.65899,
    fill: "#E9E9E9"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 24.5166,
    y: 160.138,
    width: 35.2535,
    height: 3.31797,
    rx: 1.65899,
    fill: "#E9E9E9"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 24.5166,
    y: 170.092,
    width: 40.6452,
    height: 3.31797,
    rx: 1.65899,
    fill: "#D6D6D6"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1789_42435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.5029 30.6453C93.6561 28.8045 96.6809 27.0149 98.3419 26.3706C98.0856 26.207 97.6857 25.9718 97.2346 25.7161C95.0916 26.4217 92.5897 27.9864 90.3545 29.7556C90.7339 30.042 91.1338 30.3385 91.5029 30.6453Z",
    fill: "#E31837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5179 25.6445C90.2 25.4911 89.8514 25.3479 89.5848 25.2252C88.7748 25.624 87.7187 26.2274 86.3857 27.1785C86.6728 27.3319 86.9804 27.516 87.3086 27.7C88.3339 26.9433 89.3695 26.2274 90.5179 25.6445Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4354 24.765C92.0458 24.5502 90.6923 24.0491 89.7592 23.8344C89.4824 23.9366 89.0928 24.09 88.8262 24.2025C89.1645 24.2946 90.4257 24.6321 91.5023 25.1741C91.7792 25.0411 92.1688 24.8775 92.4354 24.765Z",
    fill: "#E31837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.8519 24.632C86.6523 25.1843 85.3911 25.9411 84.7041 26.3808C84.9502 26.4933 85.1963 26.5853 85.5346 26.749C87.0521 25.7263 88.2415 25.1025 88.7132 24.8979C88.3748 24.7752 88.057 24.6934 87.8519 24.632Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3372 24.448C93.614 24.3559 93.9319 24.2741 94.2087 24.1923C93.409 23.8548 92.4041 23.4969 91.5018 23.2719C91.3583 23.3128 90.9276 23.4253 90.6303 23.5174C90.9379 23.6094 91.953 23.8446 93.3372 24.448ZM88.2822 28.2932C88.6103 28.4875 88.959 28.7534 89.2973 28.9784C91.5428 27.2398 93.7576 25.9002 96.1876 25.1434C95.8493 24.9695 95.5519 24.8161 95.1725 24.6321C93.7166 25.0002 91.225 25.9922 88.2822 28.2932Z",
    fill: "#E31837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5166 30.1135H26.1572C26.9877 30.1135 27.3773 29.684 27.3773 29.0807C27.3773 28.5898 27.121 28.2625 26.5878 28.1603C27.0595 28.0478 27.2748 27.7614 27.2748 27.3421C27.2748 26.8103 26.8851 26.3808 26.0546 26.3808H24.5269V30.1135H24.5166ZM25.9418 28.5284C26.2494 28.5284 26.4648 28.6818 26.4648 28.9886C26.4648 29.3159 26.2597 29.4488 25.9418 29.4488H25.4087V28.5182H25.9418V28.5284ZM25.8393 27.0353C26.1469 27.0353 26.3622 27.1683 26.3622 27.4751C26.3622 27.7819 26.1572 27.9148 25.8393 27.9148H25.4087V27.0353H25.8393ZM30.6892 26.3706H29.7664L28.3616 30.1135H29.2947L29.551 29.3363H30.9045L31.1608 30.1135H32.1042L30.6892 26.3706ZM30.2278 27.2705L30.6687 28.6511H29.7664L30.2278 27.2705ZM36.7797 26.3706H35.9287V28.8761L34.3292 26.3706H33.3756V30.1135H34.2266V27.6183L35.8262 30.1135H36.7797V26.3706ZM40.7068 30.1135L39.4764 28.2114V30.1135H38.5638V26.3706H39.4764V28.1705L40.6453 26.3706H41.6604L40.43 28.1705L41.7732 30.1135H40.7068ZM45.003 28.2421C45.003 28.9886 45.4542 29.4488 46.0386 29.4488C46.6231 29.4488 47.0742 28.9886 47.0742 28.2421C47.0742 27.4955 46.6231 27.0353 46.0386 27.0353C45.4542 27.0353 45.003 27.4955 45.003 28.2421ZM44.0392 28.2421C44.0494 27.1478 44.8184 26.2888 46.0386 26.2888C47.2588 26.2888 48.0278 27.1478 48.038 28.2421C48.0278 29.3363 47.2588 30.1954 46.0386 30.1954C44.8184 30.1954 44.0494 29.3363 44.0392 28.2421ZM49.289 30.1135H50.2015V28.6409H51.3909V27.9251H50.2015V27.0865H51.637L51.801 26.3706H49.289V30.1135ZM56.0562 26.3706H55.1334L53.7287 30.1135H54.6618L54.9181 29.3363H56.2716L56.5279 30.1135H57.4712L56.0562 26.3706ZM55.5948 27.2705L56.0357 28.6511H55.1334L55.5948 27.2705ZM62.885 26.3706H61.8187L60.8446 28.3955L59.8705 26.3706H58.8042V30.1135H59.6244V27.608L60.8343 30.1135L62.0443 27.608V30.1135H62.8953L62.885 26.3706ZM64.6589 30.1135H67.2222V29.3977H65.5714V28.5591H66.8736V27.8637H65.5714V27.0865H67.0787L67.2428 26.3706H64.6589V30.1135ZM70.6982 30.1135H71.6928L70.7597 28.5284C71.2724 28.3852 71.5184 28.0273 71.5184 27.5058C71.5184 26.8308 71.1083 26.3808 70.1855 26.3808H68.7398V30.1238H69.6318V28.6511H69.8779L70.6982 30.1135ZM70.0112 27.066C70.3906 27.066 70.5854 27.2296 70.5854 27.5467C70.5854 27.8637 70.3906 28.0273 70.0112 28.0273H69.6216V27.066H70.0112ZM73.0565 30.1135H73.969V26.3808H73.0565V30.1135ZM78.46 29.1113C78.1114 29.3568 77.8038 29.4386 77.486 29.4386C76.7887 29.4386 76.2966 28.9579 76.2966 28.2421C76.2966 27.5262 76.7785 27.0456 77.4552 27.0456C77.7628 27.0456 78.0704 27.1274 78.4088 27.3728V26.524C78.1012 26.3502 77.7423 26.2786 77.3424 26.2786C76.1017 26.2786 75.3225 27.1376 75.3122 28.2319C75.3225 29.3363 76.0812 30.1851 77.3424 30.1851C77.7628 30.1851 78.1217 30.1135 78.4498 29.9397V29.1113H78.46ZM81.8027 26.3706H80.8799L79.4751 30.1135H80.4082L80.6645 29.3363H82.018L82.2743 30.1135H83.2176L81.8027 26.3706ZM81.3413 27.2705L81.7822 28.6511H80.8799L81.3413 27.2705Z",
    fill: "#012169"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2392 44.9533C29.209 44.6703 29.0815 44.45 28.8568 44.2923C28.6344 44.1346 28.3449 44.0557 27.9885 44.0557C27.7379 44.0557 27.523 44.0935 27.3437 44.1691C27.1644 44.2448 27.0272 44.3474 26.9322 44.477C26.8371 44.6066 26.7885 44.7545 26.7864 44.9209C26.7864 45.0591 26.8177 45.179 26.8803 45.2805C26.9451 45.3821 27.0326 45.4685 27.1428 45.5398C27.2529 45.6089 27.375 45.6672 27.5089 45.7147C27.6429 45.7622 27.7779 45.8022 27.9139 45.8346L28.5361 45.9901C28.7866 46.0485 29.0275 46.1273 29.2586 46.2267C29.4919 46.326 29.7004 46.4513 29.884 46.6025C30.0698 46.7538 30.2167 46.9363 30.3247 47.1501C30.4327 47.364 30.4867 47.6146 30.4867 47.9019C30.4867 48.2907 30.3873 48.6331 30.1886 48.929C29.9898 49.2228 29.7025 49.4528 29.3267 49.6192C28.953 49.7833 28.5004 49.8654 27.969 49.8654C27.4528 49.8654 27.0045 49.7855 26.6243 49.6257C26.2463 49.4658 25.9504 49.2325 25.7365 48.9258C25.5248 48.619 25.4103 48.2453 25.3931 47.8047H26.5757C26.593 48.0358 26.6643 48.228 26.7896 48.3814C26.9149 48.5348 27.078 48.6493 27.2789 48.7249C27.4819 48.8005 27.7087 48.8383 27.9593 48.8383C28.2207 48.8383 28.4497 48.7994 28.6462 48.7216C28.845 48.6417 29.0005 48.5315 29.1128 48.3911C29.2252 48.2486 29.2824 48.0822 29.2846 47.8921C29.2824 47.7193 29.2316 47.5768 29.1323 47.4644C29.0329 47.3499 28.8936 47.2549 28.7143 47.1793C28.5371 47.1015 28.3298 47.0324 28.0922 46.9719L27.3372 46.7775C26.7907 46.6371 26.3586 46.4243 26.0411 46.1392C25.7257 45.8519 25.568 45.4706 25.568 44.9954C25.568 44.6044 25.6739 44.262 25.8856 43.9683C26.0994 43.6745 26.39 43.4466 26.7572 43.2846C27.1244 43.1204 27.5402 43.0383 28.0047 43.0383C28.4756 43.0383 28.8882 43.1204 29.2424 43.2846C29.5989 43.4466 29.8786 43.6723 30.0816 43.9618C30.2847 44.2491 30.3895 44.5796 30.3959 44.9533H29.2392ZM33.9918 44.788V45.6953H31.1307V44.788H33.9918ZM31.837 43.5956H33.01V48.268C33.01 48.4257 33.0337 48.5467 33.0813 48.6309C33.131 48.713 33.1958 48.7692 33.2757 48.7994C33.3556 48.8296 33.4442 48.8448 33.5414 48.8448C33.6148 48.8448 33.6818 48.8394 33.7423 48.8286C33.8049 48.8178 33.8524 48.808 33.8848 48.7994L34.0825 49.7164C34.0198 49.738 33.9302 49.7617 33.8136 49.7877C33.6991 49.8136 33.5587 49.8287 33.3923 49.833C33.0985 49.8417 32.8339 49.7974 32.5985 49.7002C32.363 49.6008 32.1762 49.4474 32.0379 49.2401C31.9018 49.0327 31.8349 48.7735 31.837 48.4624V43.5956ZM36.4049 49.8654C36.0895 49.8654 35.8055 49.8093 35.5527 49.6969C35.3022 49.5825 35.1034 49.414 34.9565 49.1915C34.8118 48.969 34.7394 48.6946 34.7394 48.3685C34.7394 48.0876 34.7913 47.8554 34.895 47.6718C34.9987 47.4882 35.1402 47.3413 35.3194 47.2311C35.4987 47.121 35.7007 47.0378 35.9254 46.9816C36.1522 46.9233 36.3866 46.8812 36.6285 46.8553C36.9201 46.825 37.1566 46.798 37.3381 46.7743C37.5195 46.7484 37.6513 46.7095 37.7334 46.6576C37.8176 46.6036 37.8598 46.5205 37.8598 46.4081V46.3887C37.8598 46.1446 37.7874 45.9556 37.6427 45.8217C37.4979 45.6877 37.2895 45.6208 37.0173 45.6208C36.73 45.6208 36.5021 45.6834 36.3336 45.8087C36.1673 45.934 36.055 46.0819 35.9966 46.2526L34.9015 46.0971C34.9879 45.7946 35.1304 45.5419 35.3292 45.3389C35.5279 45.1336 35.7709 44.9803 36.0582 44.8788C36.3455 44.7751 36.663 44.7232 37.0108 44.7232C37.2506 44.7232 37.4893 44.7513 37.7269 44.8075C37.9645 44.8636 38.1816 44.9565 38.3782 45.0861C38.5748 45.2136 38.7325 45.3875 38.8513 45.6078C38.9722 45.8281 39.0327 46.1035 39.0327 46.4341V49.765H37.9051V49.0813H37.8662C37.795 49.2195 37.6945 49.3492 37.5649 49.4701C37.4375 49.5889 37.2765 49.6851 37.0821 49.7585C36.8899 49.8298 36.6641 49.8654 36.4049 49.8654ZM36.7095 49.0035C36.9449 49.0035 37.1491 48.9571 37.3219 48.8642C37.4947 48.7692 37.6276 48.6439 37.7204 48.4883C37.8155 48.3328 37.863 48.1632 37.863 47.9796V47.3932C37.8263 47.4234 37.7636 47.4515 37.6751 47.4774C37.5887 47.5033 37.4915 47.526 37.3835 47.5454C37.2754 47.5649 37.1685 47.5822 37.0627 47.5973C36.9568 47.6124 36.865 47.6254 36.7873 47.6362C36.6123 47.6599 36.4557 47.6988 36.3174 47.7528C36.1792 47.8068 36.0701 47.8824 35.9902 47.9796C35.9102 48.0747 35.8703 48.1978 35.8703 48.349C35.8703 48.565 35.9491 48.7281 36.1068 48.8383C36.2645 48.9485 36.4654 49.0035 36.7095 49.0035ZM42.6974 44.788V45.6953H39.8363V44.788H42.6974ZM40.5427 43.5956H41.7156V48.268C41.7156 48.4257 41.7394 48.5467 41.7869 48.6309C41.8366 48.713 41.9014 48.7692 41.9813 48.7994C42.0612 48.8296 42.1498 48.8448 42.247 48.8448C42.3205 48.8448 42.3874 48.8394 42.4479 48.8286C42.5105 48.8178 42.5581 48.808 42.5905 48.7994L42.7881 49.7164C42.7255 49.738 42.6358 49.7617 42.5192 49.7877C42.4047 49.8136 42.2643 49.8287 42.098 49.833C41.8042 49.8417 41.5396 49.7974 41.3041 49.7002C41.0687 49.6008 40.8818 49.4474 40.7435 49.2401C40.6075 49.0327 40.5405 48.7735 40.5427 48.4624V43.5956ZM45.8282 49.8622C45.3293 49.8622 44.8983 49.7585 44.5354 49.5511C44.1747 49.3416 43.8971 49.0457 43.7027 48.6633C43.5083 48.2788 43.4111 47.8263 43.4111 47.3057C43.4111 46.7937 43.5083 46.3444 43.7027 45.9577C43.8992 45.5689 44.1736 45.2665 44.5257 45.0505C44.8778 44.8323 45.2915 44.7232 45.7667 44.7232C46.0734 44.7232 46.3629 44.7729 46.6351 44.8723C46.9094 44.9695 47.1513 45.1207 47.3609 45.3259C47.5726 45.5311 47.7389 45.7925 47.8599 46.11C47.9808 46.4254 48.0413 46.8013 48.0413 47.2376V47.5973H43.9619V46.8067H46.917C46.9148 46.582 46.8662 46.3822 46.7711 46.2072C46.6761 46.0301 46.5433 45.8908 46.3726 45.7892C46.2041 45.6877 46.0075 45.637 45.7829 45.637C45.5431 45.637 45.3325 45.6953 45.151 45.8119C44.9696 45.9264 44.8281 46.0776 44.7266 46.2656C44.6272 46.4513 44.5764 46.6555 44.5743 46.878V47.5681C44.5743 47.8576 44.6272 48.106 44.7331 48.3134C44.8389 48.5186 44.9869 48.6763 45.177 48.7864C45.3671 48.8944 45.5896 48.9485 45.8444 48.9485C46.0151 48.9485 46.1695 48.9247 46.3078 48.8772C46.446 48.8275 46.5659 48.7551 46.6675 48.6601C46.769 48.565 46.8457 48.4473 46.8975 48.3069L47.9927 48.43C47.9236 48.7195 47.7918 48.9722 47.5974 49.1882C47.4051 49.4021 47.1589 49.5684 46.8586 49.6872C46.5584 49.8039 46.2149 49.8622 45.8282 49.8622ZM49.0336 49.765V44.788H50.1547V45.6337H50.2131C50.3167 45.3486 50.4885 45.1261 50.7282 44.9662C50.968 44.8042 51.2542 44.7232 51.5869 44.7232C51.9239 44.7232 52.2079 44.8053 52.4391 44.9695C52.6724 45.1315 52.8365 45.3529 52.9316 45.6337H52.9834C53.0936 45.3572 53.2794 45.1369 53.5408 44.9727C53.8043 44.8064 54.1164 44.7232 54.4772 44.7232C54.9351 44.7232 55.3088 44.868 55.5983 45.1574C55.8877 45.4469 56.0325 45.8692 56.0325 46.4243V49.765H54.8563V46.6058C54.8563 46.2969 54.7742 46.0711 54.61 45.9286C54.4458 45.7838 54.245 45.7115 54.0073 45.7115C53.7244 45.7115 53.5029 45.8 53.3431 45.9772C53.1854 46.1522 53.1066 46.38 53.1066 46.6609V49.765H51.9563V46.5572C51.9563 46.3001 51.8785 46.0949 51.723 45.9415C51.5696 45.7882 51.3687 45.7115 51.1203 45.7115C50.9518 45.7115 50.7985 45.7547 50.6602 45.8411C50.522 45.9253 50.4118 46.0452 50.3297 46.2008C50.2476 46.3541 50.2066 46.5334 50.2066 46.7386V49.765H49.0336ZM59.4258 49.8622C58.9268 49.8622 58.4958 49.7585 58.1329 49.5511C57.7722 49.3416 57.4946 49.0457 57.3002 48.6633C57.1058 48.2788 57.0086 47.8263 57.0086 47.3057C57.0086 46.7937 57.1058 46.3444 57.3002 45.9577C57.4968 45.5689 57.7711 45.2665 58.1232 45.0505C58.4753 44.8323 58.889 44.7232 59.3642 44.7232C59.671 44.7232 59.9604 44.7729 60.2326 44.8723C60.5069 44.9695 60.7489 45.1207 60.9584 45.3259C61.1701 45.5311 61.3364 45.7925 61.4574 46.11C61.5784 46.4254 61.6388 46.8013 61.6388 47.2376V47.5973H57.5594V46.8067H60.5145C60.5123 46.582 60.4637 46.3822 60.3687 46.2072C60.2736 46.0301 60.1408 45.8908 59.9701 45.7892C59.8016 45.6877 59.6051 45.637 59.3804 45.637C59.1406 45.637 58.93 45.6953 58.7486 45.8119C58.5671 45.9264 58.4256 46.0776 58.3241 46.2656C58.2247 46.4513 58.174 46.6555 58.1718 46.878V47.5681C58.1718 47.8576 58.2247 48.106 58.3306 48.3134C58.4364 48.5186 58.5844 48.6763 58.7745 48.7864C58.9646 48.8944 59.1871 48.9485 59.442 48.9485C59.6126 48.9485 59.7671 48.9247 59.9053 48.8772C60.0436 48.8275 60.1635 48.7551 60.265 48.6601C60.3665 48.565 60.4432 48.4473 60.495 48.3069L61.5902 48.43C61.5211 48.7195 61.3893 48.9722 61.1949 49.1882C61.0027 49.4021 60.7564 49.5684 60.4562 49.6872C60.1559 49.8039 59.8124 49.8622 59.4258 49.8622ZM63.8041 46.8488V49.765H62.6312V44.788H63.7523V45.6337H63.8106C63.9251 45.3551 64.1076 45.1336 64.3582 44.9695C64.6109 44.8053 64.9231 44.7232 65.2946 44.7232C65.6381 44.7232 65.9372 44.7967 66.1921 44.9436C66.4492 45.0904 66.6479 45.3032 66.7883 45.5819C66.9309 45.8605 67.0011 46.1986 66.999 46.5961V49.765H65.826V46.7775C65.826 46.4449 65.7396 46.1846 65.5668 45.9966C65.3961 45.8087 65.1596 45.7147 64.8572 45.7147C64.652 45.7147 64.4694 45.7601 64.3096 45.8508C64.1519 45.9394 64.0277 46.0679 63.937 46.2364C63.8484 46.4049 63.8041 46.609 63.8041 46.8488ZM70.6766 44.788V45.6953H67.8155V44.788H70.6766ZM68.5218 43.5956H69.6948V48.268C69.6948 48.4257 69.7186 48.5467 69.7661 48.6309C69.8158 48.713 69.8806 48.7692 69.9605 48.7994C70.0404 48.8296 70.129 48.8448 70.2262 48.8448C70.2996 48.8448 70.3666 48.8394 70.4271 48.8286C70.4897 48.8178 70.5373 48.808 70.5697 48.7994L70.7673 49.7164C70.7047 49.738 70.615 49.7617 70.4984 49.7877C70.3839 49.8136 70.2435 49.8287 70.0771 49.833C69.7834 49.8417 69.5188 49.7974 69.2833 49.7002C69.0478 49.6008 68.861 49.4474 68.7227 49.2401C68.5867 49.0327 68.5197 48.7735 68.5218 48.4624V43.5956Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1789_42435",
    x: 0.829493,
    y: 0.829493,
    width: 150.646,
    height: 200,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.829493,
    dy: 0.829493
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1789_42435"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1789_42435",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1789_42435"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 73.8249,
    height: 7.46544,
    fill: "white",
    transform: "translate(24.5166 23.2719)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReconcile);
export default __webpack_public_path__ + "static/media/reconcile.aa40277b33699c9ed1c8fabf235da32a.svg";
export { ForwardRef as ReactComponent };